import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { engageNestedRoutes } from '../../app-routes';
import { EngageSettingsNavigator } from './EngageSettingsNavigator';
import { EditAutomationTemplate } from './edit-automation-template';
import { EditSegmentPage } from './edit-segment';

export const EngageSetup: React.FC = () => {
  // Routes are relative to /dashboard/engage/* where this component is rendered
  return (
    <div className="space-y-6">
      <Routes>
        <Route path={engageNestedRoutes.AUTOMATIONS_EDIT} element={<EditAutomationTemplate />} />
        <Route path={engageNestedRoutes.SEGMENTS_NEW} element={<EditSegmentPage />} />
        <Route path={engageNestedRoutes.SEGMENTS_EDIT} element={<EditSegmentPage />} />
        <Route path=":tab?" element={<EngageSettingsNavigator />} />
      </Routes>
    </div>
  );
};
